import { FormikProps, getIn } from 'formik'
import React, { FC, useEffect, useId } from 'react'
import { DateTimeInput, Label } from '..'
import { FontSize, formatDateTimeToInput, validateDate } from '../../../_metronic/helpers'
import { useT } from '_metronic/i18n/Metronici18n'

interface IFormDateTimeInput {
  label?: string
  name: string
  placeholder?: string
  formik: FormikProps<any>
  isDisabled?: boolean
  isRequired?: boolean
  className?: string
  labelSize?: FontSize
  infoText?: string
  highlight?: boolean
  min?: Date
  max?: Date
  entity?: string
}

export const FormDateTimeInput: FC<IFormDateTimeInput> = ({
  label,
  name,
  placeholder,
  formik,
  isDisabled = false,
  className = '',
  isRequired = false,
  labelSize,
  infoText,
  highlight,
  min,
  max,
  entity,
}) => {
  const { t } = useT()
  const errorMessage = getIn(formik.errors, name, null)
  const touched = getIn(formik.touched, name, '')
  const value = getIn(formik.values, name, '')
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) =>
    formik.setFieldValue(name, e.target.value)

  // Data inválida ou fora de min/max vira erro do Formik e bloqueia o submit, sem repetir a regra
  // em cada schema.
  const { registerField, unregisterField } = formik
  const minInput = min ? formatDateTimeToInput(min) : undefined
  const maxInput = max ? formatDateTimeToInput(max) : undefined
  useEffect(() => {
    registerField(name, {
      validate: (valor?: string) => validateDate(valor ?? '', minInput, maxInput) || undefined,
    })
    return () => unregisterField(name)
  }, [name, minInput, maxInput, registerField, unregisterField])

  const resolvedLabel = label ?? (entity ? t(`${entity}.label`) : undefined)
  const inputId = `${name}-${useId()}`

  return (
    <div className={`${className}`}>
      {resolvedLabel && (
        <Label
          className='mb-2'
          htmlFor={inputId}
          isRequired={isRequired}
          size={labelSize}
          infoText={infoText}
          highlight={highlight}
        >
          {resolvedLabel}
        </Label>
      )}
      <DateTimeInput
        {...formik.getFieldProps(name)}
        id={inputId}
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        onBlur={formik.handleBlur}
        disabled={formik.isSubmitting || isDisabled}
        className={touched && errorMessage ? 'is-invalid' : 'is-valid'}
        min={min}
        max={max}
        errorMessage={touched && errorMessage ? errorMessage : undefined}
      />
    </div>
  )
}
